<template>
  <section
      :id="!!id.length ? id : null"
      class="events-listing row push-v--mobile--large push-v--tablet--large"
  >
    <div class="container justify-content-lg-between">
      <p class="events-listing__title push-v--desktop--small push-v--tablet--small push-v--mobile--small">
        {{ title }}
      </p>
      <div class="events-listing__cards">
        <div
            v-for="(item, index) in itemsToShow"
            :key="index"
            class="events-listing__card"
        >
          <event-card v-bind="item" />
        </div>
      </div>
      <div v-if="items.length > 3 && showItems < items.length" class="load-more">
        <button
            class="btn--dark-green submit"
            @click="loadMore"
        >
          Load more
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import getStatic from '~/utils/get-static';
import EventCard from '~/components/components/EventCardV2.vue';

export default {
  components: {
    EventCard,
  },
  props: {

    id: { type: String, default: 'events' },
    title: { type: String, default: 'Community & Events Programme', required: true },
    intro: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default() {
        return [
          {
            title: 'Boogie',
            primaryContent: 'Lorem ipsum dolor sit amet',
            secondaryContent: 'Every morning at 8:30am',
            image: {
              url: getStatic('/images/content/events-community/yoga-girl.jpg'),
              description: 'boogie image',
            },
          },
          {
            title: 'Code',
            primaryContent: 'Lorem ipsum dolor sit amet',
            secondaryContent: 'Wednesday 22nd 8:00am Room 1',
            image: {
              url: getStatic('/images/content/events-community/code.png'),
              description: 'code image',
            },
          },
          {
            title: 'Yoga',
            primaryContent: 'Lorem ipsum dolor sit amet',
            secondaryContent: 'Every Weekend 9:00am Room 4',
            image: {
              url: getStatic('/images/content/events-community/yoga.jpg'),
              description: 'yoga image',
            },
          },
        ];
      },
    },
  },
  data() {
    return { showItems: 3 };
  },
  computed: {
    itemsToShow() {
      return this.items.slice(0, this.showItems);
    },
  },
  methods: {
    loadMore() {
      this.showItems = this.items.length;// we have a max of 6 items to show
    },
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/modules/_events-listing.scss';
</style>
